<template>
  <div class="home">
    <van-nav-bar
      :title="$t('OrderDetail.title')"
      left-arrow
      fixed
      @click-left="backToDishes()"
    >
    </van-nav-bar>
    <div class="detail_top" v-if="orderDetail">
      <div class="row1">
        <div class="top_sit" v-if="orderDetail.place">
          {{ orderDetail.place.name }}
        </div>
        <div class="top_success">
          <!-- <van-icon name="checked" color="#FFC813" size="40px"/> -->
          <van-icon name="./static/img/ok.png" size="25px" class="okIcon" />
          <div
            style="
              width: auto;
              height: 40px;
              line-height: 40px;
              float: right;
              font-size: 18px;
            "
          >
            {{ $t("OrderDetail.success") }}
          </div>
        </div>
      </div>
      <div class="top_price">
        {{ sessionStorage.getItem("currency") }}{{ orderDetail.final_price }}
      </div>
      <div class="top_price">
        <span v-if="orderDetail.status == 2">{{ $t("OrderDetail.pay") }}</span>
        <span v-else>{{ $t("OrderDetail.unpaid") }}</span>
        <!-- {{orderDetail.status==2?'已支付':'未支付'}} -->
      </div>
      <div class="top_price">
        <span
          >{{ $t("OrderDetail.serviceCharge") }}：{{
            orderDetail.service_price
          }}</span
        >
      </div>
    </div>
    <div class="orderDishes" v-if="orderDetail">
      <div class="dishItem">
        <div class="dishDetail">
          <div class="dish_name noExceed">{{ $t("OrderDetail.totalNum") }}</div>
          <div class="dish_num">X{{ orderDetail.sitter }}</div>
          <div class="dish_price noExceed"></div>
        </div>
        <!-- <div class="leftdot"></div> -->
      </div>
      <div style="height: 3px; width: 100%; background-color: #f3f5f7"></div>
      <template v-for="(dish, index) in orderDetail.package">
        <div class="dishItem">
          <div class="dishDetail">
            <div class="dish_name noExceed">{{ dish.menu_name }}</div>
            <div class="dish_num price">X{{ dish.number }}</div>
            <div class="dish_price noExceed tr">
              {{ sessionStorage.getItem("currency") }}{{ dish.price }}
            </div>
            <div v-if="dish.category == 'm'" class="dish_des noExceed">
              <template v-for="val in dish.tags_name">
                {{ val }}
              </template>
              {{ $t("PackageDetail.remark") }}：{{ dish.remark }}
            </div>
            <!-- <div  v-if="dish.category=='m'" class="type_icon">
                            <van-icon name="./static/img/cook_prepare_small.png" size="30px"/> 
                            <span>准备中</span>
                        </div> -->
          </div>
          <template v-for="(son, key) in dish.details">
            <div class="dishDetail son">
              <div class="dish_name noExceed">{{ son.menus_name }}</div>
              <div class="dish_num"></div>
              <div class="dish_price noExceed"></div>
              <div class="dish_des noExceed">
                <template v-for="val in son.tags_name">
                  {{ val }}
                </template>
                {{ $t("PackageDetail.remark") }}：{{ son.remark }}
              </div>
            </div>
          </template>
          <!-- 下单时间 -->
          <div class="infoItem">
            <div class="info_left">{{ $t("OrderDetail.time") }}</div>
            <div class="info_right">{{ dish.created_at }}</div>
          </div>
          <div class="menuIconGroup">
            <div v-if="dish.status == 0" class="type_icon">
              <van-icon
                name="./static/img/cook_prepare_small.png"
                size="30px"
              />
              <span>{{ $t("OrderDetail.status0") }}</span>
            </div>
            <div v-else-if="dish.status == 1" class="type_icon">
              <van-icon
                name="./static/img/cook_cooking_small.png"
                size="30px"
              />
              <span>{{ $t("OrderDetail.status1") }}</span>
            </div>
            <div v-else-if="dish.status == 2" class="type_icon">
              <van-icon
                name="./static/img/cook_compele_small.png"
                size="30px"
              />
              <span>{{ $t("OrderDetail.status2") }}</span>
            </div>
            <div v-else-if="dish.status == 3" class="type_icon">
              <van-icon name="./static/img/cook_finsh_small.png" size="30px" />
              <span>{{ $t("OrderDetail.status3") }}</span>
            </div>
            <div v-else-if="dish.status == 5" class="type_icon">
              <van-icon name="./static/img/cook_finsh_small.png" size="30px" />
              <span>{{ $t("OrderDetail.status5") }}</span>
            </div>
            <div v-else-if="dish.status == 4" class="type_icon">
              <van-icon name="./static/img/cook_finsh_small.png" size="30px" />
              <span>{{ $t("OrderDetail.status4") }}</span>
            </div>
          </div>
          <!-- <div class="leftdot"></div> -->
          <div
            style="height: 1px; width: 100%; background-color: #f3f5f7"
          ></div>
        </div>
      </template>
    </div>
    <div class="orderInfo">
      <div class="infoItem">
        <div class="info_left">{{ $t("OrderDetail.time") }}</div>
        <div class="info_right">{{ orderDetail.created_at }}</div>
      </div>
      <div class="infoItem">
        <div class="info_left">{{ $t("OrderDetail.orderNum") }}</div>
        <div class="info_right">{{ orderDetail.order }}</div>
      </div>
    </div>
    <div style="height: 60px"></div>
    <div
      :class="is_pay ? 'shopBottom' : 'shopBottom1'"
      v-show="orderDetail.status !== 2"
    >
      <!-- v-if="is_pay" -->
      <van-button
        class="cancelBtn"
        size="normal"
        round
        @click="payWrapper = true"
        :disabled="isSet"
        >{{ $t("OrderDetail.goPay") }}</van-button
      >
      <van-button
        :class="is_pay ? 'certainBtn' : 'certainBtn1'"
        @click="backToDishes()"
        size="normal"
        round
        >{{ $t("OrderDetail.containerOrder") }}</van-button
      >
    </div>
    <!-- 付款方式弹窗 -->
    <van-popup v-model="payWrapper" position="bottom" round>
      <van-radio-group v-model="radio" @change="onChange">
        <van-cell-group>
          <template v-if="$i18n.locale == 'zh'" v-for="(pay, key) in payMethod">
            <van-cell
              :title="pay.name_cn"
              clickable
              :data-name="pay.name_en"
              :key="key"
            >
              <van-radio slot="right-icon" :name="pay.name_en" />
            </van-cell>
          </template>
          <template v-if="$i18n.locale == 'hk'" v-for="(pay, key) in payMethod">
            <van-cell
              :title="pay.name_hk"
              clickable
              :data-name="pay.name_en"
              :key="key"
            >
              <van-radio slot="right-icon" :name="pay.name_en" />
            </van-cell>
          </template>
          <template v-if="$i18n.locale == 'en'" v-for="(pay, key) in payMethod">
            <van-cell
              :title="pay.name_en"
              clickable
              :data-name="pay.name_en"
              :key="key"
            >
              <van-radio slot="right-icon" :name="pay.name_en" />
            </van-cell>
          </template>
        </van-cell-group>
        <div style="width: 100%; height: 50px">
          <van-button
            style="
              width: 90%;
              height: 35px;
              margin-left: 5%;
              margin-top: 7px;
              line-height: 35px;
            "
            color="#2f75f4"
            round
            @click="goPay()"
            >{{ $t("OrderDetail.goPay") }}</van-button
          >
        </div>
      </van-radio-group>
    </van-popup>

    <!-- 上传凭证 -->
    <van-dialog
      v-model="isVoucher"
      :title="$t('OrderDetail.uploadVoucher')"
      :confirmButtonText="$t('OrderDetail.confirm')"
      closeOnClickOverlay
      @confirm="uploaderVoucher"
    >
      <van-uploader
        v-model="fileList"
        :max-count="1"
        :before-delete="beforeDelete"
        :after-read="afterRead"
      />
      <div>
        <p>{{ $t("OrderDetail.accountInformation") }}</p>
        <p class="info"></p>
      </div>
    </van-dialog>
    <!-- 點擊憑證圖片彈出 -->
    <van-popup v-model="showImg" v-if="img">
      <van-image fit="contain" :src="img" />
    </van-popup>
    <div class="form" v-html="content"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      orderDetail: {},
      payMethod: [],
      isSet: false,
      payWrapper: false,
      radio: "",
      is_pay: false,
      isVoucher: false, //是否上传凭证
      file: "",
      fileList: [],
      img: "",
      content: "",
      showImg: false
    };
  },
  mounted() {
    this.getOrderDetail();
    this.getPayment();
    // this.isSetPayment();
  },
  methods: {
    // 確認提交信息
    uploaderVoucher() {
      if (this.file) {
        let formData = new FormData();
        formData.append("order_id", localStorage.takeOrderId);
        formData.append("file", this.file.file);
        this.formData = formData;
        this.$axios({
          method: "post",
          url: this.$build + "/api/order/upload",
          data: formData
        })
          .then(res => {
            console.log("上傳成功", res);
            if (res.data.status == 200) {
              this.$router.push("/CashPayment");
              // this.img = res.data.data.certificates[0].image.path;
            } else {
              this.fileList = [];
              this.$toast.allowMultiple();
              for (var item in res.data.error) {
                this.$toast({
                  type: "fail",
                  message: res.data.error[item]
                });
              }
            }
          })
          .catch(err => {
            this.$toast({
              type: "fail",
              message: this.$t("OrderDetail.message")
            });
          });
      } else {
        this.$toast({
          type: "fail",
          message: this.$t("OrderDetail.voucherTip")
        });
      }
    },
    beforeDelete() {
      console.log("清空file");
      this.file = "";
      this.fileList.pop();
    },
    // 上传图片
    afterRead(file) {
      console.log("圖片信息", file);
      this.file = file;
    },
    getOrderDetail() {
      // 获取
      this.$axios({
        method: "PUT",
        headers: {
          type: sessionStorage.type,
          code: sessionStorage.code,
          placeid: sessionStorage.placeId
        },
        url:
          this.$build + "/api/order/" + this.$route.params.id + "/customerIndex"
      })
        .then(res => {
          if (res.data.status == 200) {
            console.log(res);
            this.orderDetail = res.data.data;
            this.orderDetail.package.forEach(item => {
              let arr = [];
              if (item.category == "m") {
                if (item.tags_name) {
                  console.log(item.tags_name);
                  if (item.tags_name[0] != "") {
                    item.tags_name.forEach(i => {
                      if (typeof i == "object") {
                        i.forEach(tag => {
                          arr.push(tag);
                        });
                      } else {
                        arr.push(i);
                      }
                    });
                  }
                }
                item.tags_name = arr;
              }
            });
            console.log(res.data.data.finish);
            console.log(this.orderDetail.status);
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    backToDishes() {
      if (this.orderDetail.finish == 1) {
        sessionStorage.orderType = "new";
      } else {
        sessionStorage.setItem("actOrderId", this.orderDetail.id);
        sessionStorage.setItem("orderType", "add");
      }
      this.$router.push("/Dishes");
    },
    // 判断老板是否设置支付参数
    isSetPayment() {
      this.$axios({
        method: "get",
        url:
          this.$build + "/api/store/" + sessionStorage.storeId + "/setPayment"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
            this.isSet = true;
            console.log("请去老板端设置");
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 获取可用支付方式
    getPayment() {
      this.$axios({
        method: "GET",
        headers: {
          type: sessionStorage.type,
          code: sessionStorage.code,
          placeid: sessionStorage.placeId
        },
        url:
          this.$build + "/api/store/" + sessionStorage.storeId + "/customerShow"
      })
        .then(res => {
          console.log("查看");
          if (res.data.status == 200) {
            console.log(res.data.data.is_pay, "是否先支付");
            this.is_pay = res.data.data.is_pay == 1 ? true : false;
            sessionStorage.setItem("currency", res.data.data.currency.unit);
            sessionStorage.setItem("is_quick", res.data.data.is_quick);
            if (res.data.data.insite.length > 0) {
              this.payMethod = res.data.data.insite;
              this.radio = res.data.data.insite[0].name_en;
            } else {
              this.payMethod = [];
              this.radio = "";
            }
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    onChange(val) {
      console.log(val);
    },
    // 选择支付方式去支付
    goPay() {
      localStorage.setItem("orderLineType", "insite");
      if (this.radio == "Paypal") {
        console.log("Paypal支付");
        this.pay();
      } else if (this.radio == "Mypay") {
        console.log("Mypay支付");
        this.mypay();
      } else if (this.radio == "Cash") {
        console.log("现金支付");
        this.$router.push("/CashPayment");
      } else if (this.radio == "WeChat Pay") {
        console.log("微信支付");
        this.wxpay();
      } else if (this.radio == "Alipay") {
        console.log("支付宝支付");
        this.Alipay();
      } else if (this.radio == "Apple Pay") {
        console.log("Apple支付");
      } else if (this.radio == "Credit Card") {
        console.log("信用卡支付");
      } else if (this.radio == "Line Pay") {
        console.log("LinePay支付");
        this.linepay();
      } else if (this.radio == "Apple pay") {
        console.log("ApplePay支付");
        this.Applepay();
      } else if (this.radio == "Google pay") {
        console.log("GooglePay支付");
        this.googlepay();
      } else if (this.radio == "八达通") {
        console.log("八达通支付");
        this.badatong();
      } else if (this.radio == "Voucher Payment") {
        // this.$router.push("/CashPayment");
        this.isVoucher = true;
      } else if (this.radio == "ECpay" || this.radio == "EC Pay") {
        this.ECpay();
      }
    },
    // paypal支付
    pay() {
      this.$toast.loading({
        message: this.$t("OrderDetail.loading"),
        forbidClick: true
      });
      this.$axios({
        method: "post",
        url: this.$build + "/api/paypal/pay",
        data: {
          order: this.orderDetail.order,
          code: sessionStorage.code
        }
      })
        .then(res => {
          if (res.data.status == 200) {
            console.log(res);
            window.location.href = res.data.data;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
          this.$toast.clear();
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // mypal支付
    mypay() {
      this.$toast.loading({
        message: this.$t("OrderDetail.loading"),
        forbidClick: true
      });
      this.$axios({
        method: "post",
        url: this.$build + "/api/mypays/pay",
        data: {
          order: this.orderDetail.order,
          code: sessionStorage.code
        }
      })
        .then(res => {
          if (res.data.status == 200) {
            console.log(res);
            window.location.href = res.data.data.url;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
          this.$toast.clear();
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // linepay支付
    linepay() {
      this.$toast.loading({
        message: this.$t("OrderDetail.loading"),
        forbidClick: true
      });
      this.$axios({
        method: "post",
        url: this.$build + "/api/line-pay/pay",
        data: {
          order: this.orderDetail.order
        }
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.$toast({
              type: "success",
              message: res.data.data.returnMessage
            });
            if (res.data.data.info) {
              setTimeout(() => {
                window.location.href = res.data.data.info.paymentUrl.web;
              }, 800);
            }
          } else {
            for (var item in res.data.error.message) {
              this.$toast({
                type: "fail",
                message: res.data.error.message[item]
              });
            }
          }
          this.$toast.clear();
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 微信支付
    wxpay() {
      // return;
      this.$toast.loading({
        message: this.$t("OrderDetail.loading"),
        forbidClick: true
      });
      this.$axios({
        method: "post",
        url: this.$build + "/api/wechat/pay",
        data: {
          order: this.orderDetail.order
        }
      })
        .then(res => {
          console.log(res.data);
          if (res.status == 200) {
            this.$toast({
              type: "loading",
              message: ""
            });
            var s = res.data.replace(/<script>window.location.href="/, "");
            console.log(s);
            var c2 = s.substr(0, s.length - 10);
            console.log(c2);
            window.location.href = `${c2}`;
            this.$axios({
              method: "post",
              url: this.$build + "/api/wechat/notify",
              data: null
            })
              .then(res => {
                console.log(res);
                if (res.data.status == 200) {
                  console.log(res.data);
                  this.$toast({
                    type: "success",
                    message: res.data.data.returnMessage
                  });
                } else {
                  for (var item in res.data.error.message) {
                    this.$toast({
                      type: "fail",
                      message: res.data.error.message[item]
                    });
                  }
                }
              })
              .catch(err => {
                this.$toast({
                  type: "fail",
                  message: this.$t("common.message")
                });
              });
          } else {
            for (var item in res.data.error.message) {
              this.$toast({
                type: "fail",
                message: res.data.error.message[item]
              });
            }
          }
          this.$toast.clear();
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 支付宝支付
    Alipay() {
      this.$axios({
        method: "post",
        url: this.$build + "/api/alipay/pay",
        data: {
          order: this.orderDetail.order
        }
      })
        .then(res => {
          console.log(res.data);
          this.content = res.data;
          this.$toast({
            type: "loading",
            message: ""
          });
          setTimeout(() => {
            document.forms[0].submit(); //通过submit()传递给服务器，进行响应
            this.$axios({
              method: "post",
              url: this.$build + "/api/alipay/notify",
              data: null
            })
              .then(res => {
                console.log(res);
                if (res.data.status == 200) {
                  console.log(res.data);
                  this.$toast({
                    type: "success",
                    message: res.data.data.returnMessage
                  });
                } else {
                  for (var item in res.data.error.message) {
                    this.$toast({
                      type: "fail",
                      message: res.data.error.message[item]
                    });
                  }
                }
              })
              .catch(err => {
                this.$toast({
                  type: "fail",
                  message: this.$t("common.message")
                });
              });
          }, 100);
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // ECpay支付
    ECpay() {
      this.$axios({
        method: "post",
        url: this.$build + "/api/ec-pay/pay",
        data: {
          order: this.orderDetail.order
        }
      }).then(res => {
        console.log(res);
        this.$toast({
          type: "loading",
          message: ""
        });
        window.location.href = res.data.data.url;
      });
    },
    // Apple Pay支付
    Applepay() {},
    // Google Pay支付
    googlepay() {},
    // 八达通支付
    badatong() {}
  }
};
</script>
<style scoped>
/deep/ .van-image {
  /* font-size: 0; */
  vertical-align: middle;
  max-width: 600px;
  max-height: 600px;
}
.info {
  margin: 0 auto;
  width: 300px;
  text-align: left;
  /* height: 150px; */
}
/deep/ .van-dialog {
  width: 400px;
}
/deep/ .van-uploader__upload {
  width: 250px;
  height: 200px;
}
/deep/ .van-uploader__preview-image {
  width: 250px;
  height: 250px;
}
/deep/ .van-dialog__content {
  text-align: center;
  padding: 20px 0;
}
/deep/ .van-nav-bar .van-icon {
  font-size: 26px;
  color: #fff;
}
/deep/ .van-field__body > input {
  text-align: right;
}
.okIcon {
  vertical-align: middle;
}
.home {
  width: 100%;
  height: 100vh;
  background-color: #fff;
}
.detail_top {
  padding-top: 46px;
  width: 100%;
  height: 126px;
  background-color: #f3f5f7;
  /*display: flex;
        display: -webkit-flex;
        flex-direction: column;
        justify-content:center;
        align-items: center;*/
}
.top_success {
  width: auto;
  height: 40px;
  line-height: 40px;
  padding-right: 10px;
}
.top_sit {
  height: 35px;
  line-height: 35px;
  font-size: 18px;
  padding-left: 10px;
}
.top_price {
  height: 20px;
  line-height: 20px;
  text-align: center;
  font-weight: bold;
  font-size: 22px;
  margin-top: 5px;
}
.dishDetail .price {
  text-align: left;
  color: #999;
}
.orderDishes {
  width: 100%;
  min-height: 50px;
}
.dishItem {
  width: 90%;
  margin-left: 5%;
  min-height: 35px;
  position: relative;
}
.dish_name {
  width: 60%;
  height: 35px;
  line-height: 35px;
  float: left;
}
.dish_num {
  width: 15%;
  height: 35px;
  line-height: 35px;
  float: left;
  color: #000;
}
.dish_price {
  width: 25%;
  height: 35px;
  line-height: 35px;
  color: #000;
  float: left;
  text-align: right;
}
.dishDetail .price {
  text-align: left;
  color: #000;
}
.dish_des {
  width: 100%;
  height: 20px;
  color: #999;
  clear: both;
  font-size: 14px;
}
.leftdot {
  position: absolute;
  width: 6px;
  height: 6px;
  left: -3.5%;
  top: 15px;
  background: linear-gradient(90deg, #ffc914, #ffc813);
  border-radius: 50%;
}
.totalPrice {
  width: 100%;
  height: 20px;
  line-height: 20px;
  font-size: 16px;
  text-align: right;
}
.son > div {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
}
@media screen and (min-width: 800px) {
  .shopBottom,
  .shopBottom1 {
    width: 800px;
  }
}
@media screen and (max-width: 800px) {
  .shopBottom,
  .shopBottom1 {
    width: 100%;
  }
}
.shopBottom {
  position: fixed;
  bottom: 0;
  height: 60px;
  background: #000;
  /* width: 100%; */
  display: flex;
  justify-content: space-between;
  border-radius: 5px;
}
.shopBottom1 {
  position: fixed;
  bottom: 0;
  height: 60px;
  background: #000;
  /* width: 100%; */
  /* display: flex;
  justify-content: space-between; */
}
.certainBtn1 {
  width: 30%;
  top: 8px;
  left: 35%;
  background: #2f75f4;
  color: #fff;
  border: 1px solid #2f75f4;
  font-weight: bold;
  font-size: 16px;
}
.cancelBtn {
  width: 30%;
  top: 8px;
  left: 5%;
  background: #2f75f4;
  color: #fff;
  border: 1px solid #2f75f4;
  font-weight: bold;
  font-size: 16px;
}
.certainBtn {
  width: 30%;
  top: 8px;
  right: 5%;
  background: #2f75f4;
  color: #fff;
  border: 1px solid #2f75f4;
  font-weight: bold;
  font-size: 16px;
}
.orderInfo {
  width: 90%;
  margin-left: 5%;
  height: 60px;
  padding-top: 5px;
}
.infoItem {
  width: 100%;
  height: 25px;
  font-size: 14px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: space-between;
}
.info_left {
  flex: auto;
  text-align: left;
  height: 25px;
  line-height: 25px;
}
.info_right {
  flex: auto;
  text-align: right;
  height: 25px;
  line-height: 25px;
}
.menuIconGroup {
  height: 35px;
}
.type_icon {
  width: 50%;
  height: 35px;
  line-height: 35px;
  float: left;
  display: flex;
  display: -webkit-flex;
  align-items: center;
}
.type_icon > span {
  font-size: 14px;
  text-indent: 10px;
}
.row1 {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderDetail.vue